import { MatPaginatorIntl } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

export class PaginatorI18n extends MatPaginatorIntl {

    constructor(private readonly translate: TranslateService) {
        super();

        this.translate.onLangChange.subscribe( (e: Event) => {
            this.updateTranslations();
        });

        this.updateTranslations();
    }

    updateTranslations() {
        this.translate.get(['ITEMS_PER_PAGE_LABEL', 'NEXT_PAGE_LABEL', 'PREVIOUS_PAGE_LABEL', 
                            'FIRST_PAGE_LABEL', 'LAST_PAGE_LABEL']).subscribe((translation: string) => {
                                this.itemsPerPageLabel = translation['ITEMS_PER_PAGE_LABEL'];
                                this.nextPageLabel = translation['NEXT_PAGE_LABEL'];
                                this.previousPageLabel = translation['PREVIOUS_PAGE_LABEL'];
                                this.firstPageLabel = translation['FIRST_PAGE_LABEL'];
                                this.lastPageLabel = translation['LAST_PAGE_LABEL'];
                                this.changes.next();
                            });
    }

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} / ${length}`;
    }
}